import React from 'react'
import { Paper, Grid, Typography, CircularProgress } from '@material-ui/core'

const rateColor = (rate) => {
  if (rate >= 0.9) return '#2e7d32'
  if (rate >= 0.7) return '#f57c00'
  return '#c62828'
}

const formatPct = (rate) => {
  if (rate == null || isNaN(rate)) return '—'
  return `${(rate * 100).toFixed(1)}%`
}

const StatCard = ({ title, bucket }) => {
  const rate = bucket ? bucket.successRate : null
  const color = rate == null ? '#999' : rateColor(rate)
  return (
    <Paper style={{ padding: 16, height: '100%' }}>
      <Typography variant="caption" color="textSecondary" style={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
        {title}
      </Typography>
      <Typography
        variant="h3"
        style={{ color, fontWeight: 600, marginTop: 4, lineHeight: 1.1 }}
      >
        {formatPct(rate)}
      </Typography>
      <Typography variant="body2" color="textSecondary" style={{ marginTop: 4 }}>
        {bucket ? `${bucket.success} of ${bucket.total} successful` : 'No data'}
      </Typography>
      {bucket && bucket.failed > 0 && (
        <Typography variant="caption" style={{ color: '#c62828' }}>
          {bucket.failed} failed
        </Typography>
      )}
    </Paper>
  )
}

const TopFailureCard = ({ topFailureTypes }) => {
  const top = topFailureTypes && topFailureTypes.length > 0 ? topFailureTypes[0] : null
  return (
    <Paper style={{ padding: 16, height: '100%' }}>
      <Typography variant="caption" color="textSecondary" style={{ textTransform: 'uppercase', letterSpacing: 0.5 }}>
        Top Failure Type (30d)
      </Typography>
      {top ? (
        <>
          <Typography
            variant="h6"
            style={{
              fontFamily: 'Menlo, Monaco, "Courier New", monospace',
              marginTop: 8,
              wordBreak: 'break-word',
              color: '#c62828'
            }}
          >
            {top.errorType || 'unknown'}
          </Typography>
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 4 }}>
            {top.count} occurrence{top.count !== 1 ? 's' : ''}
          </Typography>
          {topFailureTypes.length > 1 && (
            <Typography variant="caption" color="textSecondary">
              +{topFailureTypes.length - 1} more types
            </Typography>
          )}
        </>
      ) : (
        <>
          <Typography variant="h6" style={{ color: '#2e7d32', marginTop: 8 }}>
            No failures
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Last 30 days
          </Typography>
        </>
      )}
    </Paper>
  )
}

const ParseLogStats = ({ stats, loading }) => {
  if (loading && !stats) {
    return (
      <Paper style={{ padding: 24, textAlign: 'center', marginBottom: 16 }}>
        <CircularProgress size={24} />
      </Paper>
    )
  }

  if (!stats) {
    return (
      <Paper style={{ padding: 16, marginBottom: 16 }}>
        <Typography variant="body2" color="textSecondary">No stats available</Typography>
      </Paper>
    )
  }

  return (
    <Grid container spacing={2} style={{ marginBottom: 16 }}>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard title="24h Success Rate" bucket={stats.last24h} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard title="7d Success Rate" bucket={stats.last7d} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard title="30d Success Rate" bucket={stats.last30d} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TopFailureCard topFailureTypes={stats.topFailureTypes} />
      </Grid>
    </Grid>
  )
}

export default ParseLogStats
